class PageScroll {
	constructor(config) {
		this.config = Object.assign({
			scope: '.button-down'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', (e) => {
			let height = $(e.currentTarget).closest('.scroll-height').height() - 70; //70=header logo overlap, semi-responsive scroll
			$(window).scrollTop(height);
		});
	}
}

export default new PageScroll;
